import _get from 'lodash/get'

import axios from '../../_framework/axios/trip-dashboard-axios'

const travelInfoSectionName = 'travel_info'

export default {
  state: {
    Templates: _get(window, 'appInitialData.stores.TravelInfoTemplates', [])
  },
  getters: {
    TravelInfoTemplates: state => {
      return state.Templates
    }
  },
  mutations: {
    updateTravelInfoTemplates(state, payload) {
      state.Templates = payload.templates
    }
  },
  actions: {
    getTravelInfoTemplates(context) {
      axios.get('/getTravelInfoTemplates').then(response => {
        if (response.status === 200) {
          context.commit('updateTravelInfoTemplates', response.data)
        }
      })
    },
    addTravelInfoTemplate(context, payload) {
      payload.section = travelInfoSectionName
      axios.post('/addTravelInfoTemplate', payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTravelInfoTemplates', response.data)
        }
      })
    },
    updateTravelInfoTemplate(context, payload) {
      payload.section = travelInfoSectionName
      axios.post(`/updateTravelInfoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTravelInfoTemplates', response.data)
        }
      })
    },
    removeTravelInfoTemplate(context, payload) {
      payload.section = travelInfoSectionName
      axios.post(`/removeTravelInfoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTravelInfoTemplates', response.data)
        }
      })
    },
    importTravelInfoTemplate(context, payload) {
      payload.section = travelInfoSectionName
      return new Promise(resolve => {
        axios
          .post(
            `${context.getters.currentTripDashboardId}/importTravelInfoTemplate/${payload.template.id}`,
            payload
          )
          .then(response => {
            if (response.status === 200) {
              context.commit('updateStore', {
                store: 'travel_info',
                value: response.data.travel_info
              })
              resolve()
            }
          })
      })
    }
  }
}
